export const SETTINGS_ROUTES = {
    general: {
        index: 'general',
        clocks: 'clocks'
    },
    aircraft: {
        index: 'aircraft',
        acidList: 'my-fleet-acid-list',
        typeParams: 'type-parameters',
        edrOverrides: 'edr-overrides'
    },
    views: 'views',
    weather: 'weather',
    filterGroups: {
        index: 'filter-groups',
        manage: 'manage'
    },
    monitorAlert: {
        index: 'monitor-alert',
        aircraftThresholds: 'aircraft-thresholds',
        aircraftOptions: 'aircraft-options',
        airportThresholds: 'airport-thresholds',
        airportOptions: 'airport-options'
    },
    externalLinkIntegration: 'external-link-integration',
    notes: {
        index: 'notes',
        manage: 'manage'
    },
    alerts: {
        index: 'alerts',
        emails: 'emails'
    },
    diversionManager: 'diversion-manager',
    about: 'about'
};
